import { motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import Loader from "../../../../components/Loader/Loader";
import "./micrositeDetailsMedia.scss";

const MicrositeDetailsMedia = ({ data, onLoadComplete }) => {
  const [isLoading, setIsLoading] = useState(true);
  const loadCalledRef = useRef(false); // ensure onLoadComplete called once per media
  const url = data?.mediaLink?.url;
  const mediaType = data?.mediaLink?.mediaType;
  const eventLogoUrl = data?.eventLogo?.url;

  // Reset loading state when URL changes
  useEffect(() => {
    setIsLoading(true);
    loadCalledRef.current = false;
  }, [url, eventLogoUrl]);

  const markLoaded = () => {
    if (!loadCalledRef.current) {
      loadCalledRef.current = true;
      setIsLoading(false);
      onLoadComplete?.();
    }
  };

  const markError = () => {
    if (!loadCalledRef.current) {
      loadCalledRef.current = true;
      setIsLoading(false);
      onLoadComplete?.();
    }
  };

  const Wrapper = ({ children }) => (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
      className="media-container"
      style={{ paddingBottom: "0px" }}
    >
      <div className="slide">
        {isLoading && <Loader />}
        {children}
      </div>
    </motion.div>
  );

  if ((!mediaType || !url) && !eventLogoUrl) return null;

  // YouTube / Vimeo
  if (mediaType === "SOCIAL_MEDIA" || mediaType === "VIMEO_MEDIA") {
    return (
      <Wrapper>
        <ReactPlayer
          className="video-player"
          url={url}
          controls={true}
          height="100%"
          width="100%"
          onReady={markLoaded}
          onError={markError}
          style={{ opacity: isLoading ? 0 : 1, transition: "opacity 0.3s ease" }}
        />
      </Wrapper>
    );
  }

  // Image
  if (mediaType === "IMAGE" || mediaType === "DEFAULT") {
    return (
      <Wrapper>
        <img
          src={url}
          alt={mediaType === "DEFAULT" ? "Default Media" : "Media"}
          onLoad={markLoaded}
          onError={markError}
          style={{
            width: "100%",
            height: "auto",
            objectFit: "contain",
            opacity: isLoading ? 0 : 1,
            transition: "opacity 0.3s ease",
          }}
        />
      </Wrapper>
    );
  }

  // Synthesia Video
 // Synthesia Video
if (mediaType === "SYNTHESIA_MEDIA") {
  const uuidMatch = url.match(
    /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
  );

  if (!uuidMatch) return null;
  const videoId = uuidMatch[0];
  const embedUrl = `https://share.synthesia.io/embeds/videos/${videoId}`;

  return (
    <Wrapper>
      <div
        className="synthesia-video-container"
        style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}
      >
        <iframe
          src={embedUrl}
          title={data?.title || "Synthesia Video"}
          allow="autoplay; encrypted-media"
          allowFullScreen
          frameBorder="0"
          onLoad={markLoaded}
          onError={markError}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: isLoading ? 0 : 1,
            transition: "opacity 0.3s ease",
          }}
        />
      </div>
    </Wrapper>
  );
}


  if (eventLogoUrl) {
    return (
      <Wrapper>
        <img
          src={eventLogoUrl}
          alt={data?.eventName || "Event"}
          onLoad={markLoaded}
          onError={markError}
          style={{
            width: "100%",
            height: "auto",
            objectFit: "contain",
            opacity: isLoading ? 0 : 1,
            transition: "opacity 0.3s ease",
          }}
        />
      </Wrapper>
    );
  }

  return null;
};

export default MicrositeDetailsMedia;
